import React, { HTMLAttributes } from 'react';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';

import { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import { Dropdown, Avatar } from '../../../../../components';
import { ARIA_DISCLOSURE_ID_ACCOUNT_MENU } from '../../../../../config/constants';
import useAriaDisclosure from '../../../../../hooks/useAriaDisclosure';
import useClasses from '../../../../../hooks/useClasses';
import useTypedDispatch from '../../../../../hooks/useTypedDispatch';
import { toggleSupportTool } from '../../../../../store/actions/UI';
import { ImmutableMenuItem } from '../../..';
import MenuMainSubmenu from '../../Submenu';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLUListElement>> {
  entity: ImmutableMenuItem;
}

const MenuMainItemAccount: React.FC<Props> = ({ className, entity }) => {
  const dispatch = useTypedDispatch();
  const { buildClass, joinClasses } = useClasses('MenuMainItem');
  const ariaDisclosure = useAriaDisclosure<HTMLDivElement>(ARIA_DISCLOSURE_ID_ACCOUNT_MENU, {
    closeOnOutsideClick: true,
    closeOnEscape: true,
  });

  const href = entity.getIn(['link', 'url'], '');
  const title = entity.getIn(['link', 'title'], '');
  const subtree = entity.get('subtree', Immutable.List);

  const avatar = useSelector<ImmutableRootState<number>, number>((state) => {
    const uid = state.getIn(['login', 'uid']);
    return state.getIn(['user', uid, 'field_avatar', 0, 'value'], 1);
  });

  return (
    <li key={href} className={joinClasses(buildClass(), className)}>
      <button
        type="button"
        className={joinClasses(buildClass('button'), 'menu-item')}
        aria-label={title}
        {...ariaDisclosure.toggleProps}
      >
        <Avatar avatar={avatar} />
        <div className="icon icon-menu" />
      </button>
      {ariaDisclosure.isOpen && (
        <div className={buildClass('overlay')} />
      )}
      <Dropdown
        id={ARIA_DISCLOSURE_ID_ACCOUNT_MENU}
        ref={ariaDisclosure.targetRef}
        className={buildClass('dropdown')}
        isOpen={ariaDisclosure.isOpen}
      >
        <MenuMainSubmenu
          entities={subtree}
          onNavigate={(isSupportItem) => {
            ariaDisclosure.toggleIsOpen();

            if (isSupportItem) {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-call
              dispatch(toggleSupportTool(true));
            }
          }}
        />
      </Dropdown>
    </li>
  );
};

export default MenuMainItemAccount;
